import createStore from "./create"
import ApiClient from "utils/ApiClient"

const client = new ApiClient()
// @ts-ignore
export const store = createStore(client)
